import gql from 'graphql-tag';

export const SEARCH_RELEASES = gql`
  query searchReleases($idValue: String!) {
    SearchReleases(title:$idValue) {
      id,
      title
    }
  }
`;

export const GET_RELEASE = gql`
  query Release (
    $id: ID,
    $isMainRelease: Boolean,
    $grid: String,
    $isrc: String,
    $icpn: String,
    $gtin: String,
    $upc: String,
    $musicbrainzGuid: String,
    $catalogNumber: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $duration: Int,
    $compilationOf: String,
    $mediaType: String,
    $title: String,
    $subtitle: String,
    $type: String,
    $isMultiArtistCompilation: Boolean,
    $pLineText: String,
    $pLineIsDefault: Boolean,
    $pLineYear: String,
    $pLineCompany: String,
    $cLineText: String,
    $cLineIsDefault: Boolean,
    $cLineYear: String,
    $cLineCompany: String,
  ) {
  Release(
    id: $id,
    isMainRelease: $isMainRelease,
    grid: $grid,
    isrc: $isrc,
    icpn: $icpn,
    gtin: $gtin,
    upc: $upc,
    musicbrainzGuid: $musicbrainzGuid,
    catalogNumber: $catalogNumber,
    proprietaryId: $proprietaryId,
    proprietaryIdNamespace: $proprietaryIdNamespace,
    duration: $duration,
    compilationOf: $compilationOf,
    mediaType: $mediaType,
    title: $title,
    subtitle: $subtitle,
    type: $type,
    isMultiArtistCompilation: $isMultiArtistCompilation,
    pLineText: $pLineText,
    pLineIsDefault: $pLineIsDefault,
    pLineYear: $pLineYear,
    pLineCompany: $pLineCompany,
    cLineText: $cLineText,
    cLineIsDefault: $cLineIsDefault,
    cLineYear: $cLineYear,
    cLineCompany: $cLineCompany,
  ) {
    id,
    isMainRelease,
    grid,
    isrc,
    icpn,
    gtin,
    upc,
    musicbrainzGuid,
    catalogNumber,
    proprietaryId,
    proprietaryIdNamespace,
    duration,
    compilationOf,
    mediaType,
    title,
    subtitle,
    type,
    isMultiArtistCompilation,
    pLineText,
    pLineIsDefault,
    pLineYear,
    pLineCompany,
    cLineText,
    cLineIsDefault,
    cLineYear,
    cLineCompany,
    parentRelease {
      id,
      type,
      title,
      releaseDetails {
        id,
        artwork {
          id,
          type,
          file {
            uri
          }
        }
      }
    }
    subReleases {
      id,
      type,
      title,
      releaseDetails {
        id,
        artwork {
          id,
          type,
          file {
            uri
          }
        }
      }
    }
    recording {
      id,
      title,
      contributions {
        contributor {
          id,
          fullName
        }
        role,
        isCredited,
        creditText,
        featured
      }
      file {
        uri
      }
    }
    video {
      id,
      title,
      file {
        uri
      }
    }
    releaseDetails {
      id,
      artwork {
        id,
        type,
        file {
          uri
        }
      }
      texts {
        id,
        text,
        type,
        depicts {
          id,
          fullName
        }
      }
      owners {
        id,
        fullName,
        imageDepictions {
          id,
          file {
            id,
            uri
          }
        }
      }
      releasedBy {
        id,
        fullName,
        imageDepictions {
          id,
          file {
            id,
            uri
          }
        }
      }
    }
    genres {
      id,
      name
    }
  }
}
`;

export const CREATE_RELEASE = gql`
  mutation createRelease (
    $id: ID,
    $isMainRelease: Boolean,
    $grid: String,
    $isrc: String,
    $icpn: String,
    $gtin: String,
    $upc: String,
    $musicbrainzGuid: String,
    $catalogNumber: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $duration: Int,
    $compilationOf: String,
    $mediaType: String,
    $title: String,
    $subtitle: String,
    $type: String,
    $isMultiArtistCompilation: Boolean,
    $pLineText: String,
    $pLineIsDefault: Boolean,
    $pLineYear: String,
    $pLineCompany: String,
    $cLineText: String,
    $cLineIsDefault: Boolean,
    $cLineYear: String,
    $cLineCompany: String,
  ) {
  CreateRelease(
    id: $id,
    isMainRelease: $isMainRelease,
    grid: $grid,
    isrc: $isrc,
    icpn: $icpn,
    gtin: $gtin,
    upc: $upc,
    musicbrainzGuid: $musicbrainzGuid,
    catalogNumber: $catalogNumber,
    proprietaryId: $proprietaryId,
    proprietaryIdNamespace: $proprietaryIdNamespace,
    duration: $duration,
    compilationOf: $compilationOf,
    mediaType: $mediaType,
    title: $title,
    subtitle: $subtitle,
    type: $type,
    isMultiArtistCompilation: $isMultiArtistCompilation,
    pLineText: $pLineText,
    pLineIsDefault: $pLineIsDefault,
    pLineYear: $pLineYear,
    pLineCompany: $pLineCompany,
    cLineText: $cLineText,
    cLineIsDefault: $cLineIsDefault,
    cLineYear: $cLineYear,
    cLineCompany: $cLineCompany,
  ) {
    id,
    isMainRelease,
    grid,
    isrc,
    icpn,
    gtin,
    upc,
    musicbrainzGuid,
    catalogNumber,
    proprietaryId,
    proprietaryIdNamespace,
    duration,
    compilationOf,
    mediaType,
    title,
    subtitle,
    type,
    isMultiArtistCompilation,
    pLineText,
    pLineIsDefault,
    pLineYear,
    pLineCompany,
    cLineText,
    cLineIsDefault,
    cLineYear,
    cLineCompany,
  }
}
`;

export const UPDATE_RELEASE = gql`
  mutation updateRelease (
    $id: ID!,
    $isMainRelease: Boolean,
    $grid: String,
    $isrc: String,
    $icpn: String,
    $gtin: String,
    $upc: String,
    $musicbrainzGuid: String,
    $catalogNumber: String,
    $proprietaryId: String,
    $proprietaryIdNamespace: String,
    $duration: Int,
    $compilationOf: String,
    $mediaType: String,
    $title: String,
    $subtitle: String,
    $type: String,
    $isMultiArtistCompilation: Boolean,
    $pLineText: String,
    $pLineIsDefault: Boolean,
    $pLineYear: String,
    $pLineCompany: String,
    $cLineText: String,
    $cLineIsDefault: Boolean,
    $cLineYear: String,
    $cLineCompany: String,
  ) {
  UpdateRelease(
    id: $id,
    isMainRelease: $isMainRelease,
    grid: $grid,
    isrc: $isrc,
    icpn: $icpn,
    gtin: $gtin,
    upc: $upc,
    musicbrainzGuid: $musicbrainzGuid,
    catalogNumber: $catalogNumber,
    proprietaryId: $proprietaryId,
    proprietaryIdNamespace: $proprietaryIdNamespace,
    duration: $duration,
    compilationOf: $compilationOf,
    mediaType: $mediaType,
    title: $title,
    subtitle: $subtitle,
    type: $type,
    isMultiArtistCompilation: $isMultiArtistCompilation,
    pLineText: $pLineText,
    pLineIsDefault: $pLineIsDefault,
    pLineYear: $pLineYear,
    pLineCompany: $pLineCompany,
    cLineText: $cLineText,
    cLineIsDefault: $cLineIsDefault,
    cLineYear: $cLineYear,
    cLineCompany: $cLineCompany,
  ) {
    id,
    isMainRelease,
    grid,
    isrc,
    icpn,
    gtin,
    upc,
    musicbrainzGuid,
    catalogNumber,
    proprietaryId,
    proprietaryIdNamespace,
    duration,
    compilationOf,
    mediaType,
    title,
    subtitle,
    type,
    isMultiArtistCompilation,
    pLineText,
    pLineIsDefault,
    pLineYear,
    pLineCompany,
    cLineText,
    cLineIsDefault,
    cLineYear,
    cLineCompany,
  }
}
`;

export const DELETE_RELEASE = gql`
  mutation deleteRelease (
    $id: ID!
  ) {
  DeleteRelease(
    id: $id
  ) {
    id
  }
}
`;

// AddReleaseSubReleases(
//   from: _ReleaseInput!
//   to: _ReleaseInput!
// ): _AddReleaseSubReleasesPayload
// RemoveReleaseSubReleases(
//   from: _ReleaseInput!
//   to: _ReleaseInput!
// ): _RemoveReleaseSubReleasesPayload
// AddReleaseRecording(
//   from: _ReleaseInput!
//   to: _RecordingInput!
// ): _AddReleaseRecordingPayload
// RemoveReleaseRecording(
//   from: _ReleaseInput!
//   to: _RecordingInput!
// ): _RemoveReleaseRecordingPayload
// AddReleaseVideo(
//   from: _ReleaseInput!
//   to: _VideoInput!
// ): _AddReleaseVideoPayload
// RemoveReleaseVideo(
//   from: _ReleaseInput!
//   to: _VideoInput!
// ): _RemoveReleaseVideoPayload
// AddReleaseRelatedReleases(
//   from: _ReleaseInput!
//   to: _ReleaseInput!
// ): _AddReleaseRelatedReleasesPayload
// RemoveReleaseRelatedReleases(
//   from: _ReleaseInput!
//   to: _ReleaseInput!
// ): _RemoveReleaseRelatedReleasesPayload
// AddReleaseReleaseDetails(
//   from: _ReleaseInput!
//   to: _ReleaseDetailInput!
// ): _AddReleaseReleaseDetailsPayload
// RemoveReleaseReleaseDetails(
//   from: _ReleaseInput!
//   to: _ReleaseDetailInput!
// ): _RemoveReleaseReleaseDetailsPayload
// AddReleaseReleaseDeals(
//   from: _ReleaseInput!
//   to: _ReleaseDealInput!
// ): _AddReleaseReleaseDealsPayload
// RemoveReleaseReleaseDeals(
//   from: _ReleaseInput!
//   to: _ReleaseDealInput!
// ): _RemoveReleaseReleaseDealsPayload
// AddReleaseGenres(
//   from: _GenreInput!
//   to: _ReleaseInput!
// ): _AddReleaseGenresPayload
// RemoveReleaseGenres(
//   from: _GenreInput!
//   to: _ReleaseInput!
// ): _RemoveReleaseGenresPayload
